<template>
    <div class="head">
        <!-- 头部 -->
        <div class="publicHeaders">
            <img src="../assets/img/index/banner-2026.png" alt="" class="header">
            <div class="headerSearchRow">
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="spacer"></span>
                <span class="searchSlot">
                    <div class="headerSearch">
                        <el-input v-model="searchKeyword" placeholder="搜索" clearable @keyup.enter.native="headerSearch">
                            <el-button slot="append" icon="el-icon-search" @click="headerSearch"></el-button>
                        </el-input>
                    </div>
                </span>
            </div>
        </div>

        <!-- 导航栏 -->
        <div class="menuTab">
            <div class="top">
                <span
                    v-for="(item, index) in menuTabTopList"
                    :key="index"
                    :class="getMenuItemClass(item.name)"
                    @click="jump(item)"
                >{{ item.name }}</span>
            </div>
            <div class="bottom">
                <span
                    v-for="(item, index) in menuTabBottomList"
                    :key="index"
                    :class="getMenuItemClass(item.name)"
                    @click="jump(item)"
                >{{ item.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '../api/api'
export default {
    name: 'publicHeaders',
    data() {
        return {
            searchKeyword: '',
            menuTabTopList: [
                {
                    name: '首页',
                    title: '首页',
                    url: '/',
                    urlName: 'index',
                },
                {
                    name: '新闻中心',
                    title: '新闻中心',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '信用企业',
                    title: '信用企业',
                    url: '/evaluateCompanySearch',
                    urlName: 'evaluateCompanySearch',
                },
                // {
                //     name: '信用评价',
                //     title: '信用评价',
                //     url: '/creditEvaluate'
                // },
                {
                    name: '星级诚信企业',
                    title: '星级诚信企业',
                    url: '/starLevelSearch',
                    urlName: 'starLevelSearch',
                },
                {
                    name: '企业诚信官',
                    title: '企业诚信官',
                    url: '/',
                    urlName: '',
                },
                {
                    name: '信用专家',
                    title: '信用专家',
                    url: '/personSearch',
                    urlName: 'personSearch',
                },
                {
                    name: '信用案例',
                    title: '信用案例',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '信用指数',
                    title: '信用指数',
                    url: '/publicList',
                    urlName: 'publicList',
                },
            ],
            menuTabBottomList: [
                {
                    name: '政策法规',
                    title: '政策法规',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '企业资讯',
                    title: '企业资讯',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '机构动态',
                    title: '机构动态',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '信用管理',
                    title: '信用管理',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '诚信倡议单位',
                    title: '诚信倡议单位',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '企业合规官',
                    title: '企业合规官',
                    url: '/personSearch',
                    urlName: 'https://ccoedu.org.cn/web.html',
                },
                {
                    name: '信用研究',
                    title: '信用研究',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '信用报告',
                    title: '信用报告',
                    url: '/publicList',
                    urlName: 'publicList',
                },
                {
                    name: '信用标准',
                    title: '信用标准',
                    url: '/publicList',
                    urlName: 'publicList',
                },
            ]
        }
    },
    created() {
        this.applyHomeMenu()
        this.getIndexInfo()
    },
    methods: {
        getMenuItemClass(name) {
            return {
                longMenuItem: ['星级诚信企业', '诚信倡议单位'].includes(name),
                mediumMenuItem: ['企业诚信官', '企业合规官', '企业合作官'].includes(name)
            }
        },
        applyHomeMenu() {
            let path = this.$route.path
            if (path == '/developForum' || path == '/forum_list' || path == '/forum_detail') {
                this.menuTabTopList[0] = {
                    name: '首页',
                    title: '诚信经典',
                    url: '/developForum',
                    urlName: 'developForum',
                }
            } else {
                this.menuTabTopList[0] = {
                    name: '首页',
                    title: '首页',
                    url: '/',
                    urlName: 'index',
                }
            }
        },
        // 获取企业诚信官链接
        getIndexInfo() {
            let _this = this
            api.getIndexInfo().then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    // console.log(data.data.websiteLink[9][0].linkUrl);
                    if (data.data.websiteLink[9]) {
                        _this.menuTabTopList[5].urlName = data.data.websiteLink[9][0].linkUrl
                    } else {
                        _this.menuTabTopList[5].urlName = ''
                    }
                }
            })
            
        },

        jump(item) {
            if (item.url != '/') {
                // 外链直接打开
                if (item.urlName && item.urlName.startsWith('http')) {
                    window.open(item.urlName, '_blank');
                    return;
                }
                if (item.url == '/creditEvaluate') {
                    this.$router.push({
                        name: item.urlName,
                        query: {
                            documentTitle: item.title,
                            active: 0
                        }
                    })
                    // window.open(routeUrl.href+ '?documentTitle=' + item.title + '&active=0', '_blank');
                } else {
                    this.$router.push({
                        name: item.urlName,
                        query: {
                            documentTitle: item.title
                        }
                    })
                    // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
                }
            } else {
                if (item.urlName == 'index') {
                    this.$router.push({
                        name: item.urlName
                    })
                } else {
                    // console.log(item.urlName);
                    // let routeUrl = this.$router.resolve({
                    //   path: item.urlName
                    // });
                    // console.log(routeUrl);
                    if (item.urlName == '') {
                        console.log('暂未配置链接')
                    } else {
                        window.open(item.urlName, '_blank');
                    }
                    
                }
            }
        },

        // 头部搜索
        headerSearch() {
            if (this.searchKeyword.trim()) {
                this.$router.push({
                    name: 'publicList',
                    query: {
                        documentTitle: '搜索"' + this.searchKeyword + '"的结果',
                        searchName: this.searchKeyword
                    }
                })
                this.searchKeyword = ''
            }
        }
    }
}
</script>

<style lang="less" scoped>
.head {
    width: calc(100% - 10px);
    margin: 0 auto;
    @media only screen and (min-width: 769px) {
        min-width: 1360px; /*no*/
    }
    /* padding: 0 50px; */
    .publicHeaders {
        position: relative;
        /* margin-top: 30px; */
        .header {
            width: 100%;
        }
        .headerSearchRow {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 18px;
            display: flex;
            padding: 0 12%;
            min-height: 40px;
            align-items: center;
            pointer-events: none;
            span {
                flex: 1;
                text-align: center;
            }
            .searchSlot {
                flex: 2;
                position: relative;
                overflow: visible;
            }
            .headerSearch {
                position: absolute;
                left: 0;
                right: calc(25% - 2em);
                top: 50%;
                transform: translateY(-50%);
                pointer-events: auto;
            }
        }
    }
    .menuTab {
        color: #fff;
        background-color: #0449AE;
        padding: 10px 0;
        .top {
            padding: 4px 12%;
            display: flex;
            span {
                flex: 1;
                cursor: pointer;
                text-align: center;
                white-space: nowrap;
                font-weight: bold;
            }
            .longMenuItem {
                flex: 1.35;
            }
            .mediumMenuItem {
                flex: 1.18;
            }
            span:nth-of-type(n+2) {
                border-left: 1px solid #98C8F8;
            }
        }
        .bottom {
            padding: 4px 12%;
            /* background-color: #E8F1FF; */
            display: flex;
            margin-top: 2px;
            span {
                flex: 1;
                cursor: pointer;
                text-align: center;
                white-space: nowrap;
                font-weight: bold;
            }
            .longMenuItem {
                flex: 1.35;
            }
            .mediumMenuItem {
                flex: 1.18;
            }
            span:nth-of-type(n+2) {
                border-left: 1px solid #98C8F8;
            }
        }
    }
}
</style>

